import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';
import { IRootScopeService, ITimeoutService } from 'angular';
import { CurrentUserService } from 'services/currentUser';
import { HippoApiService } from 'services/hippoApi';
import { PermissionService } from 'services/permission';
import { get, isEqual } from 'lodash';

const module = angular.module('ach-payment-method', []);

interface AchPaymentMethod extends angular.IStrictController {
    edit: () => void;
    cancel: () => void;
    save: () => void;
    achDetails: AchDetails;
    policyInfo: CustomerPolicyInfo;
    accountHolderName: string;
    routingNumber: string;
    accountNumber: string;
    showSpinner: boolean;
    last4: string;
    errorMessage: string;
    canEditACH: boolean;
    paymentMethodUpdateStatus: string;
    paymentStatusText: string;
    paymentStatusSubText: string;
    shouldShowPaymentFailedMessage: boolean;
    achError: string;
}

module.component('achPaymentMethod', {
    bindings: {
        policyInfo: '<',
        title: '<',
        onPaymentMethodChange: '&'
    },
    template: template,
    controller: function(
        this: AchPaymentMethod,
        $timeout: ITimeoutService,
        hippoApiService: HippoApiService,
        $rootScope: IRootScopeService,
        currentUserService: CurrentUserService,
        permissionService: PermissionService,
        $scope: angular.IScope
    ) {
        const updateDisplay = () => {
            const { last4 = '', account_holder_name = '', routing_number = '' }: AchInfoDetails = this.policyInfo
                .checkout_data.ach_info
                ? get(this, 'policyInfo.checkout_data.ach_info')
                : {};
            this.last4 = last4;
            this.showSpinner = false;
            this.achDetails = {
                account_holder_name: account_holder_name,
                routing_number: routing_number,
                account_number: last4
            };
        };

        this.cancel = () => {
            updateDisplay();
            $scope.$emit('closePaymentEditSection');
        };

        this.$onChanges = (changesObj) => {
            const policyInfo = changesObj.policyInfo;
            if (policyInfo && policyInfo.currentValue !== undefined) {
                this.policyInfo = policyInfo.currentValue;
                this.canEditACH = permissionService.canEditPaymentMethod(this.policyInfo);
                updateDisplay();
            }
        };

        const getBankAccountToken = (accountData: AchDetails) => {
            const stripe = window.Stripe(this.policyInfo.checkout_data.stripe_key);
            const { account_holder_name, routing_number, account_number } = accountData;
            const bankAccountPayload: stripe.BankAccountTokenOptions = {
                country: 'US',
                currency: 'usd',
                account_holder_type: 'individual',
                account_holder_name,
                routing_number,
                account_number
            };
            return stripe.createToken('bank_account', bankAccountPayload);
        };

        const showPaymentFailedMessage = () => {
            this.shouldShowPaymentFailedMessage = true;
            this.showSpinner = false;
        };

        const achInfoNotBeenUpdated = () => {
            const achInfo = get(this, 'policyInfo.checkout_data.ach_info');
            if (!achInfo) {
                return false;
            }
            return (
                this.achDetails.account_number === achInfo.last4 &&
                this.achDetails.account_holder_name === achInfo.account_holder_name &&
                this.achDetails.routing_number === achInfo.routing_number
            );
        };

        this.save = () => {
            if (achInfoNotBeenUpdated()) {
                $scope.$emit('closePaymentEditSection');
                return;
            }

            this.showSpinner = true;

            getBankAccountToken(this.achDetails)
                .then((result) => {
                    if (result && result.token) {
                        const tokenId = result.token.id;
                        const policyId = this.policyInfo.id;
                        const policyInfoUpdate: CustomerPolicyInfoUpdate = {
                            checkout_data: {
                                payment_method: 'ach',
                                payment_token: tokenId,
                                accepts_ach_terms: true
                            }
                        };
                        hippoApiService
                            .updateCustomerPolicy(policyId, policyInfoUpdate)
                            .then(() => {
                                currentUserService.getUpdatedCustomerPolicyInfos();
                            })
                            .then(() => {
                                $rootScope.$emit('updatedCustomerPolicyInfos');
                                $scope.$emit('closePaymentEditSection');
                            })
                            .catch(() => {
                                $timeout(() => {
                                    showPaymentFailedMessage();
                                });
                            });
                    } else {
                        $timeout(() => {
                            showPaymentFailedMessage();
                        });
                    }
                })
                .catch(() => {
                    showPaymentFailedMessage();
                });
        };
    }
});

export { module };
